if (!customElements.get('piecework-dropdowns')) {
  customElements.define(
    'piecework-dropdowns',
    class PieceworkDropdowns extends HTMLElement {
      constructor() {
        super();

        this.dropdowns = this.querySelectorAll('details');
        this.dropdowns.forEach((targetDetail) => {
          targetDetail.addEventListener('click', () => {
            // Close all the details that are not targetDetail.
            this.dropdowns.forEach((detail) => {
              if (detail !== targetDetail) {
                detail.removeAttribute('open');
              }
            });
          });
        });
      }
    }
  );
}
